import {filter} from "lodash";

const DEFAULT_MARGIN = 15; // px
const LARGE_CANVAS_SIDE = 1840; // px

export class PhotoTransformService {

    centrePhoto(ph) {
        if (ph.storedHeight > ph.height) {
            ph.y += Math.round((ph.storedHeight - ph.height)/2);
        } else if (ph.storedHeight < ph.height){
            ph.y -= Math.round((ph.height - ph.storedHeight)/2);
        }

        if (ph.storedWidth > ph.width) {
            ph.x += Math.round((ph.storedWidth - ph.width)/2);
        } else if (ph.storedWidth < ph.width) {
            ph.x -= Math.round((ph.width - ph.storedWidth)/2);
        }
        return ph;
    }

    getMargin(arr, type) {
        let defaultMargin = DEFAULT_MARGIN;

        if (arr.length < 2) {
            return defaultMargin;
        }

        let lastEl = arr[arr.length - 1];
        let prewEl = arr[arr.length - 2];

        let newMargin = 0;

        if (type === "landscape") {
            newMargin = lastEl.x - (prewEl.x + prewEl.width);
        } else {
            newMargin = lastEl.y - (prewEl.y + prewEl.height);
        }

        return newMargin < defaultMargin ? defaultMargin : newMargin;
    }

    removeOverlap(arr, ratio) {

        if (arr.length <= 1) {
            return arr;
        }
        let type = ratio === "landscape" ? "width" : "height";
        let cr = ratio === "landscape" ? "x" : "y";

        for (let i = 0; i < arr.length - 1; i++) {
            let ph1 = arr[i];
            let ph2 = arr[i + 1];

            if (ph1[type] + ph1[cr] > ph2[cr] + DEFAULT_MARGIN) {
                ph2[cr] = ph1[type] + ph1[cr] + DEFAULT_MARGIN;
            }
        }

        arr = filter(arr, (ph) => {
            return ph[cr] + ph[type] <= LARGE_CANVAS_SIDE;
        });

        return arr;
    }


}


// WEBPACK FOOTER //
// ./sources/services/photo-transform.js